import { pendingTask, begin, end } from 'react-redux-spinner';
import * as Types from '../action-types';
import DataService from '../../services/data-service';
import serviceUtils from '../../utils/service-utils';

let dataActions = {
    enumRequest: function(type) {
        return (dispatch, getState) => {
            dispatch(dataActions.enumRequestBegin());
            let service = new DataService(getState().oidc.user !== null ? getState().oidc.user.id_token : '');
            service.getEnum(type)
                .then((response) => {
                    return serviceUtils.checkForFetchServerError(response,'Server Error : Unable to contact the inventory web service.');
                })
                .then((data) => {
                    dispatch(dataActions.enumRequestSuccess(type, data));
                })
                .catch((error) => { 
                    dispatch(dataActions.enumRequestError(type,error));
                    throw (error); 
                });
        };
    },
    enumRequestBegin: function() {
        return {
            type: Types.ENUM_REQUEST_BEGIN,
            results: null,
            [ pendingTask ]: begin
        };
    },
    enumRequestSuccess: function(enumType, results) {
        return {
            type: Types.ENUM_REQUEST_SUCCESS,
            enumType: enumType,
            results: results,
            [ pendingTask ]: end
        };
    },
    enumRequestError: function(enumType,error) {
        return {
            type: Types.ENUM_REQUEST_ERROR,
            enumType: enumType,
            error: error,
            results: null,
            [ pendingTask ]: end
        };
    }
}

export default dataActions;
